import type { FaireProductEntity } from "../../entity_types/product";

export const p_live_ayoh_dill_pickle_mayo_6_pack: FaireProductEntity = {
  token: "p_live_ayoh_dill_pickle_mayo_6_pack",
  type: "product",
  name: "Dill Pickle Mayo (6-pack)",
  brandToken: "b_live_ayoh_foods",
  brandName: "AYOH Foods",
  imageUrl:
    "https://cdn.faire.com/fastly/09a1a57d630676855bd56cd6cc571bd7090aa9c0d9d00331f74838f13383689b.jpeg?bg-color=FFFFFF&fit=crop&format=jpg&height=400&width=400",
  priceDollars: 25.99,
  msrpDollars: 51.84,
  description: "AYOH dill pickle mayo in a 6-pack format.",
  categoryTokens: ["cat_food-drink"],
  tags: ["live-shopping", "bestseller", "condiments"],
  isBestseller: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "live-shopping-migration",
  },
};
